export const styles = {
  chip: {
    margin: '0 8px 8px 0',
    maxWidth: 290,
  },
  head: {
    height: 4,
    position: 'absolute',
    top: '-2px',
    left: 6,
    backgroundColor: '#fff',
    width: 47,
  },
  label: {
    height: 12,
    position: 'absolute',
    top: -12,
    left: 6,
    backgroundColor: '#fff',
    width: 47,
  },
};
